import axios from "axios";

export const brandList = async () => {
    try {
        const response = await axios.get("/api/brands");
        // console.log("response", response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const xirifyEnv = async () => {
    try {
        const response = await axios.get("api/xirify/env");
        // console.log("response", response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const deleteBrand = async (payload) => {
    // console.log("payload", payload);
    try {
        const response = await axios.delete(`/api/brands/deleteBrand/${payload}`);
        // console.log("response", response);
        return response;
    } catch (err) {
        console.log(err);
    }
}

export const updateBrand = async (payload) => {
    // console.log("payload", payload);
    try {
        const response = await axios.patch(`/api/brands/updateBrand/${payload._id}`, payload);
        // console.log("response", response);
        return response;
    } catch (err) {
        console.log(err);
    }
}

export const addBrand = async (payload) => {
    // console.log("payload", payload);
    try {
        const response = await axios.post(`/api/brands/createBrand`, payload);
        // console.log("response", response);
        return response;
    } catch (err) {
        console.log(err);
    }
}

